import { atom } from 'recoil';
import type { Utils } from '@sparrow-marketing/contracts';
import type { CollapseStatus, QuickStartSetup } from './types';

export type ActivationFlowTypes =
  | 'account'
  | 'datasources'
  | 'destination'
  | 'report';

export const QuickStartState = atom<
  Utils.DynamicObject<Exclude<QuickStartSetup, 'dashboard'>, CollapseStatus>
>({
  key: 'quick-start-setup-key',
  default: {
    account: 'completed',
    datasources: 'pending',
    destination: 'pending',
    report: 'pending',
  },
});

export const QuickStartActiveStepState = atom<QuickStartSetup>({
  key: 'quick-start-active-step',
  default: 'datasources',
});

export const QuickStartDatasourceModal = atom<boolean>({
  key: 'quick-start-datasource-modal',
  default: false,
});
